import { render, staticRenderFns } from "./DOTSDetail.vue?vue&type=template&id=3d93c4d8"
import script from "./DOTSDetail.vue?vue&type=script&lang=js"
export * from "./DOTSDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports